import { required, minValue, maxValue } from 'react-admin';

export const nonNegative = [required(), minValue(0)];
export const perRun = [required(), minValue(1), maxValue(100)];
export const ttlHours = [required(), minValue(1)];
